import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-factory-listing', {
    mixins: [AppListing]
});